/**
 * @description Hook to get the voucher employees
 * @param {function} queryKey - The query key to get the voucher employees
 * @param {function} queryFn - The query function to get the voucher employees
 * @returns {VoucherEmployeesResponse} - The voucher employees
 */

import { useQuery } from "@tanstack/react-query";
import { getVoucherEmployees } from "@/features/vouchers/services/voucherEmployee.service";
import type { VoucherEmployeesResponse } from "@/features/vouchers/types/voucherEmployee.type";

export const useVoucherEmployees = () => {
  return useQuery<VoucherEmployeesResponse>({
    queryKey: ["voucherEmployees"],
    queryFn: getVoucherEmployees,
  });
};
